import Vue from 'vue'
import Swal from 'sweetalert2'

const swal = (...args) => Swal.fire(...args)

for (const key of Object.getOwnPropertyNames(Swal)) {
  if (['length', 'name', 'prototype'].includes(key)) continue

  const value = Swal[key]
  swal[key] = typeof value === 'function' ? value.bind(Swal) : value
}

Vue.swal = swal
Vue.prototype.$swal = swal
